// extracted by mini-css-extract-plugin
module.exports = {"buttons":"AppDownload_buttons__114Cg","spinAround":"AppDownload_spinAround__1e-Fl"};